"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AnimalCauseHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="90814" id="cuidamos-da-sua-saúde" className="relative w-full overflow-hidden bg-slate-50 pt-32 pb-24 lg:pt-40 lg:pb-32 flex items-center justify-center min-h-[80vh] dark:bg-background">
            <div ref={ref} className={`container relative z-20 mx-auto px-4 flex flex-col items-center text-center gap-10 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620776/img/image_4hfgr314.jpg" alt="Clínica Santa Cruz" className="w-full max-w-4xl rounded-2xl shadow-2xl" />
                <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-primary max-w-4xl leading-tight drop-shadow-sm">
                    Cuidamos da Sua <span className="text-chart-2">Saúde</span> com Dedicação
                </h1>

                <Button asChild size="lg" className="mt-4 bg-chart-2 hover:bg-chart-2/90 text-white rounded-md px-10 py-7 text-xl font-semibold shadow-2xl shadow-chart-2/40 transition-all duration-300 hover:-translate-y-1 hover:shadow-chart-2/60">
                    <Link to="#agende-a-sua-visita">Contactar</Link>
                </Button>
            </div>
        </section>;
}